import DateFormatFilter from './dateFormat.js';
import TimestampToDateFormatFilter from './timestampToDateFromat.js';
import BeautifyStatusFilter from './beautifyStatus.js';

const FiltersModule = angular.module('app.filters', [])
    .filter('dateFormat', DateFormatFilter)
    .filter('timestampToDateFormat', TimestampToDateFormatFilter)
    .filter('beautifyStatus', BeautifyStatusFilter);

export default FiltersModule;



// WEBPACK FOOTER //
// ./src/app/filters/index.js